import type {Vocabulary} from "ajv/dist/core"
import refKeyword from "ajv/dist/vocabularies/core/ref"

const core: Vocabulary = [
  "$schema",
  "id",
  "$defs",
  {keyword: "$comment"},
  "definitions",
  refKeyword,
]

export default core
